export default "__VITE_ASSET__d4122828__"